// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"IBVGiD","panelContainer":"_3TgC0R","title":"_16cUcu","generateOutlineAttributes":"_2rK3-t","body":"_2RYuyE"};